/* eslint-disable @typescript-eslint/indent */

import { IMetaDataOptions, MetaData } from './MetaData';
import { ITitleInfoProps, TitleInfo } from './TitleInfo';

export interface ITransactionHeaderOptions
  extends ITitleInfoProps,
    IMetaDataOptions {}

export interface ITransactionHeaderProps extends ITransactionHeaderOptions {}

/**
 * -----------------------------------------------------------------------------
 * It renders a header with title info and meta data
 */
export function TransactionHeader({
  actions,
  name,
  text,
  time,
  variant,
}: Readonly<ITransactionHeaderProps>) {
  return (
    <div className="flex flex-col justify-between gap-2 border-gray-100 px-4 py-1 sm:flex-row">
      <TitleInfo text={text} time={time} />
      <MetaData actions={actions} name={name} variant={variant} />
    </div>
  );
}
